import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type CenterTotalCosts = {
  totalCost: number
  finalTotalCost: number
  balance: number
  finalBalance: number
  totalPayedBalance: number
}

export function getCenterTotalCosts(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterTotalCosts.url, { id }))
    .get<CenterTotalCosts>()
}
